export default __webpack_public_path__ + "static/media/avatar.398d52f2.png";